define('lib/Podio.Transport.Embeds',['require','lib/Podio.Transport','lib/Podio.Routes'],function(require) {

  var transport = require('lib/Podio.Transport');
  var routes = require('lib/Podio.Routes');

  function create(url, app_id, callback, errorHandler) {
    return transport.postJSON(routes.embeds_path(), {'requestData': { 'url': url, 'app_id': app_id }, 'errorHandler': errorHandler}, callback);
  }

  return  {
    create: create
  };

});



